import React, { useState, useEffect } from "react";
import img1 from "../../assets/SignInAsset/1.jpg";
import img2 from "../../assets/SignInAsset/2.jpg";
import img3 from "../../assets/SignInAsset/3.jpg";
import img4 from "../../assets/SignInAsset/4.jpg";
import img5 from "../../assets/SignInAsset/5.jpg";
import img6 from "../../assets/SignInAsset/6.jpg";
import img7 from "../../assets/SignInAsset/7.jpg";
import img8 from "../../assets/SignInAsset/8.jpg";
// import { ChevronLeft, ChevronRight } from "lucide-react";

const images = [img1, img6, img2, img3, img4,img5,img7, img8];

const Slideshow: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const [isPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isPaused]);

  return (
    <div 
      className="relative w-full h-full p-3" 
      //onMouseEnter={() => setIsPaused(false)}
      //onMouseLeave={() => setIsPaused(false)}
    >
      {/* Slides */}
      <div className="relative w-full h-full">
        {images.map((src, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              current === index ? "opacity-100" : "opacity-0"
            }`}
          >
            <img src={src} alt={`Slide ${index}`} className="w-full h-full object-cover rounded-[30px] " />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Slideshow;
